export default class DateTimeFormats {
  static readonly shortDate: string = 'dd.MM.yyyy';
  static readonly time: string = 'HH:mm';
  static readonly dateTime: string = 'dd.MM.yyyy HH:mm';
  static readonly year: string = 'yyyy';
  static readonly medium: string = 'dd.MM.yyyy, HH:mm:ss';
  static readonly yearAndMonth: string = 'MM.yyyy';
}
